import styled from "styled-components";

export const Container = styled.div` `;

export const Logo = styled.div` `;

export const Img = styled.img` `;

export const Name = styled.div` `;
